import { useSelector } from 'react-redux';
import { ResultListItemClickable } from '@/components/resultList/components/ResultListItemClickable';
import { useExperiment } from '@/hooks/experiments';
import type { Offer, PaleState } from '@/interfaces';
import { ResultListItem } from '../resultList/components/ResultListItem';

type MapOfferCardProps = {
    offer: Offer | null;
    onClose: () => void;
};

export const MapOfferCard = ({ offer, onClose }: MapOfferCardProps) => {
    const filters = useSelector((s: PaleState) => s.filters);

    const experiment = useExperiment();
    const variant = experiment?.['travel-prepackage-clickable_result_item_v2'];
    const ItemComponent = variant === 'treatment' ? ResultListItemClickable : ResultListItem;

    return (
        <div className="relative mx-16 mb-16 max-w-[600px] w-[calc(100%-32px)] pointer-events-auto rounded-8 shadow-lg s-bg">
            <button
                type="button"
                aria-label="Lukk"
                title="Lukk"
                onClick={onClose}
                className="absolute -top-8 -right-8 w-32 h-32 flex items-center justify-center s-bg border s-border rounded-full shadow-md hover:s-bg-hover z-20"
                data-testid="closeMapCard">
                <w-icon name="Close" size="small" locale="nb" aria-hidden></w-icon>
            </button>
            {offer ? <ItemComponent offer={offer} filters={filters} variant={variant} /> : <div>Loading...</div>}
        </div>
    );
};
